import React from 'react';
import {FaCalendar, FaClipboardCheck} from "react-icons/fa";
import {FaFilePen, FaLocationPin} from "react-icons/fa6";
import projectUtils from "../../../../../../../utils/project-utils.js";
import I18nKeys from "../../i18n-keys.js";
import DivisorItem from "./divisor-item.jsx";
import Button from "../../../../../../../components/button/button.jsx";

const OccurrenceDetails = ({data}) => {

    const open = () =>  projectUtils.openOccurrence(data.id)

    return (
        <>
            <p className={`text-[16px] font-bold text-white p-2 bg-[#67cd8b] mb-0`}>{data.reasons}</p>
            <div className={"p-2"}>
                <DivisorItem icon={<FaCalendar size={18}/>} text={"Data do fato"} value={projectUtils.formatDate(data.factDateIni)}/>
                <DivisorItem icon={<FaLocationPin size={18}/>} text={"Endereço"} value={data.address}/>
                <DivisorItem icon={<FaClipboardCheck size={18}/>} text={"Status"} value={I18nKeys[data.status] || ""}/>
                <DivisorItem icon={<FaFilePen size={18}/>} text={"Descrição"} value={data.description}/>

                <Button variant="primary" onClick={open}>
                    Abrir cadastro
                </Button>
            </div>
        </>
    )
};

export default OccurrenceDetails;